export default __webpack_public_path__ + "ea4626f612e90595cfd085e326052bd5.svg";